import EventList from '../../../features/customer/event/EventList';
import Head from 'next/head';

const EventPage = ({ history }) => {
  return (
    <>
      <Head>
        <meta
          property="og:description"
          itemProp="description"
          content={'진행하는 이벤트 더 알아보기'}
        />
        <meta name="description" content="진행하는 이벤트 더 알아보기" />
      </Head>
      <EventList history={history} />
    </>
  );
};

export default EventPage;
